import { UserStorageActions } from 'reactApp/modules/user/userStorage';

const LOCAL_STORAGE_KEY = 'cloud-renamed-file-id' as const;

export type RenamedFileMeta = {
    newId: string;
    outdateId: string;
};

export const getRenamedFileIdInsideViewer =
    (id = LOCAL_STORAGE_KEY) =>
    (dispatch, getState): RenamedFileMeta | null =>
        UserStorageActions.get(id)(dispatch, getState);

export const setRenamedFileIdInsideViewer = (init: RenamedFileMeta) => (dispatch, getState) => {
    UserStorageActions.set(LOCAL_STORAGE_KEY, JSON.stringify(init))(dispatch, getState);
};

export const clearRenamedFileIdInsideViewer =
    (id = LOCAL_STORAGE_KEY) =>
    (dispatch, getState) => {
        UserStorageActions.remove(id)(dispatch, getState);
    };
